import { memoize } from 'lodash';
import { RootState } from '../..';
import { EntityId } from '@reduxjs/toolkit';

export const selectFiles = (state: RootState) => state.files.entities;
export const selectFilesIds = (state: RootState) => state.files.ids;
export const selectFileById = memoize((id: EntityId) => (state: RootState) => state.files.entities[id]!);
